/*!
 * froala_editor v4.0.16 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2022 Froala Labs
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('froala-editor')) :
  typeof define === 'function' && define.amd ? define(['froala-editor'], factory) :
  (factory(global.FroalaEditor));
}(this, (function (FE) { 'use strict';

  FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  Object.assign(FE.DEFAULTS, {
    trackChangesEnabled: false,
    showChangesEnabled: false
  });

  FE.PLUGINS.track_changes = function (editor) {
    var $ = editor.$; // To check if html elment-1 is after html element-2
    // Usage: $(startNode).isAfter($(endNode))

    (function () {
      $.fn.isAfter = function ($elm) {
        var $this = $(this);
        var $myParents = $this.parents();
        var $elmParents = $elm.parents();
        var $myTreeLast = $this;

        for (var i in $myParents) {
          var $elmTreeLast = $elm;

          if (!$myParents.hasOwnProperty(i)) {
            continue;
          }

          var $parent = $($myParents[i]);

          for (var j in $elmParents) {
            if (!$elmParents.hasOwnProperty(j)) {
              continue;
            }

            var $elmParent = $($elmParents[j]);

            if ($parent[0] === $elmParent[0]) {
              var myTreePos = $myTreeLast.index();
              var elmTreePos = $elmTreeLast.index();
              return myTreePos > elmTreePos;
            }

            $elmTreeLast = $elmParent;
          }

          $myTreeLast = $parent;
        }

        return false;
      };
    })();

    var pendingChanges = [];
    var prevNodeValue = '';
    var prevNode = '';
    var prevOffset = '';
    var nextSiblng = '';
    var lastDeletedNode = [];
    var lastDeletedText = [];
    var lastBlocks = null;
    var trackArr = [];
    var isHandledInBeforeInput = false;
    var iosPrevNodeValue;
    var iosPostNodeValue;

    function isValidKey(e) {
      // Undo/Redo shortcuts
      if (editor.keys.ctrlKey(e)) {
        if (e.which === FE.KEYCODE.Z || e.which === FE.KEYCODE.C) {
          return false;
        }
      } // Numbers


      if (e.keyCode >= 48 && e.keyCode <= 57) {
        return true;
      } // Alphabets


      if (e.keyCode >= 65 && e.keyCode <= 90 || e.keyCode >= 97 && e.keyCode <= 122) {
        return true;
      } // Special characters


      if (e.keyCode >= 186 && e.keyCode <= 222) {
        return true;
      } // Enter and backspace


      if (e.keyCode === 13 || e.keyCode === 8 || e.keyCode === 32 || e.keyCode === 46) {
        return true;
      } // Numpad keys


      if (e.keyCode >= 96 && e.keyCode <= 111) {
        return true;
      }

      return false;
    } // bind events


    editor.events.on('keydown', function (e) {
      var _editor$selection$get, _editor$selection$get2;

      if (!editor.opts.trackChangesEnabled) {
        return true;
      }

      iosPrevNodeValue = (_editor$selection$get = editor.selection.get()) === null || _editor$selection$get === void 0 ? void 0 : (_editor$selection$get2 = _editor$selection$get.focusNode) === null || _editor$selection$get2 === void 0 ? void 0 : _editor$selection$get2.nodeValue;

      if (editor.helpers.isAndroid()) {
        var _selection$focusNode, _prevNode;

        // Null check added
        var selection = editor.selection.get();
        prevNodeValue = selection === null || selection === void 0 ? void 0 : (_selection$focusNode = selection.focusNode) === null || _selection$focusNode === void 0 ? void 0 : _selection$focusNode.nodeValue;
        prevNode = selection === null || selection === void 0 ? void 0 : selection.focusNode;
        nextSiblng = (_prevNode = prevNode) === null || _prevNode === void 0 ? void 0 : _prevNode.nextSibling;
        prevOffset = selection === null || selection === void 0 ? void 0 : selection.focusOffset;
      } else if (isValidKey(e)) {
        if (editor.keys.ctrlKey(e) && (e.key === 'b' || e.key === 'i' || e.key === 'u')) {
          wrapFormat();
        } else if (editor.keys.ctrlKey(e) && e.key === 'a' || editor.keys.ctrlKey(e) && e.key === 's') {
          //skip wrapping on ctrl+a and ctrl + s
          return;
        } else {
          wrapChange(e);
        }
      }
    }, true);
    editor.events.on('keyup', function (e) {
      if (!editor.opts.trackChangesEnabled) {
        return true;
      } // Handle tracking on deletion, for IOS and Mobile
      // Adding the deleted items back to html, On 'keyup' for tracking purpose.
      // Insertion is handled in else part


      if (editor.helpers.isMobile()) {
        var _editor$selection$get3, _editor$selection$get4;

        iosPostNodeValue = (_editor$selection$get3 = editor.selection.get()) === null || _editor$selection$get3 === void 0 ? void 0 : (_editor$selection$get4 = _editor$selection$get3.focusNode) === null || _editor$selection$get4 === void 0 ? void 0 : _editor$selection$get4.nodeValue;

        if (isHandledInBeforeInput) {
          for (var i = 0; i < trackArr.length; i++) {
            // Removing unwanted Invisble Space.
            if (editor.opts.showChangesEnabled) {
              $(trackArr[i].span).empty();
            }

            $(trackArr[i].span).prepend(trackArr[i]["delete"]);
          }

          trackArr = [];
          isHandledInBeforeInput = false;
        } else if (editor.helpers.isIOS()) {
          for (var _i = 0; _i < trackArr.length; _i++) {
            // Disable selection on deleted node(IOS), by using css instead of contenteditable.
            if (iosPostNodeValue && iosPostNodeValue.length === 1 && iosPrevNodeValue && iosPrevNodeValue.length == 1) {
              $(trackArr[_i]["delete"]).attr('contenteditable', 'true');
              $(trackArr[_i]["delete"]).addClass('fr-ios-mobile-disable-select');
              continue;
            }

            $(trackArr[_i]["delete"]).attr('contenteditable', 'false');
          }

          trackArr = [];
        } else {
          if (e.keyCode === 46) {
            return true;
          }

          wrapChange(e);
        }
      }
    }, true); // Handle tracking of deletion for mobile devices, 
    // As KeyUp events doesn't contain proper selection range.
    // Beforeinput is used to track if backspace pressed.

    editor.events.on('beforeinput', function (e) {
      var oriEvent = e.originalEvent;
      var isDeletion = false;

      if (!editor.opts.trackChangesEnabled) {
        return true;
      }

      if (editor.helpers.isAndroid()) {
        var sel = editor.selection.get();
        var range = editor.selection.ranges(0);
        var nodeStart = range.startContainer,
            nodeEnd = range.endContainer;
        var startParentTracking = $(nodeStart).parentsUntil(editor.$el, '[data-tracking=true]'),
            endParentTracking = $(nodeEnd).parentsUntil(editor.$el, '[data-tracking=true]'); // isDeletion for keyboards, where the key is 'Unidentified'

        if (oriEvent.inputType === 'insertCompositionText') {
          if (oriEvent.data === '') {
            isDeletion = true;
          } else {
            if (sel.toString().length > oriEvent.data.length) {
              // Stop adding extra characters on deletion.
              if (startParentTracking.length > 0 || endParentTracking.length > 0) {
                isHandledInBeforeInput = true;
                e.preventDefault();
                return false;
              }

              isDeletion = true;
              e.composing = true;
            }
          }
        }

        if (oriEvent.inputType === 'insertText' && !editor.selection.isCollapsed()) {
          isDeletion = true;
        } // inputType === 'deleteContentBackward' for keyboards other than G-board


        if (isDeletion || oriEvent.inputType === 'deleteContentBackward') {
          var _nodeStart$lastChild$, _nodeStart$lastChild$2;

          isHandledInBeforeInput = true; // Stop wraping of already deleted/added content in previous node.

          if (nodeStart.lastChild && !sel.toString() && (_nodeStart$lastChild$ = nodeStart.lastChild.children) !== null && _nodeStart$lastChild$ !== void 0 && (_nodeStart$lastChild$2 = _nodeStart$lastChild$.item(0)) !== null && _nodeStart$lastChild$2 !== void 0 && _nodeStart$lastChild$2.hasAttribute('contenteditable')) {
            return; // do nothing
          }

          e.keyCode = 8;
          e.deletion = true;
          wrapChange(e);
        }
      }
    }, true); // Handle tracking of paste content to editor

    editor.events.on('paste.before', function (e) {
      if (editor.opts.trackChangesEnabled && editor.helpers.isMobile()) {
        wrapChange(e);
      }
    }, true);
    editor.events.on('paste.after', function (e) {
      if (!editor.opts.trackChangesEnabled) {
        return;
      }

      editor.markers.insert();
      var marker = editor.$el.find('.fr-marker');
      var trackingEl = marker.parent().data('tracking') ? marker.parent() : marker.parent().find('[data-tracking=true]');
      var isCollapsed = trackingEl.children().eq(0).is('ul');
      var nextEl = marker.next();

      while (nextEl.is('br')) {
        nextEl = nextEl.next();
        nextEl.prev().remove();

        if (nextEl.next().is('br')) {
          nextEl.next().remove();
        }
      }

      if (nextEl.is('ul')) {
        var liElem = nextEl.find('li');
        liElem.find('[data-tracking=true]').addClass('fr-highlight-change');
        var liHtml = liElem[0].innerHTML;
        liElem.html("");
        liElem.insertAfter(marker.closest('li')); // No tracking on mouse paste issue

        if (nextEl.parent().find('[data-tracking=true]').length == 0) {
          liElem.append(liHtml);
          return;
        }

        nextEl.remove();

        if (trackingEl.data('tracking')) {
          var trackingHtml = trackingEl[0].innerHTML;

          if (trackingHtml.trim().length > 0) {
            trackingEl.parent().append(trackingHtml);
          }

          liElem.append(trackingEl);
          trackingEl.html(liHtml);
        } else if (!isCollapsed) {
          trackingEl.insertBefore(trackingEl.closest('ul'));
          trackingEl.next().remove();
          return;
        }

        editor.markers.remove();

        if (liElem.next().length && liElem.next().is('li') && liElem.next().text().trim() == "") {
          liElem.next().remove();
        }

        var prevLiFirstChild = liElem.prev().children().eq(0);

        if (prevLiFirstChild.is('br')) {
          prevLiFirstChild.remove();
        }
      }
    }, true); // Insert tracking property for new images

    editor.events.on('image.inserted', function ($img) {
      if (editor.helpers.isMobile() && editor.opts.trackChangesEnabled) {
        $img.data('tracking-img', true);
      }
    }); // track image remove changes

    editor.events.on('image.removed', function ($img) {
      if (editor.helpers.isMobile() && editor.opts.trackChangesEnabled && !$img.data('tracking-img') && !$img.parent().data('tracking')) {
        var range = editor.selection.ranges(0);
        var node = range.startContainer;
        var parentTracking = $(node).parentsUntil(editor.$el, '[data-tracking=true]');
        editor.markers.insert();
        var marker = editor.$el.find('.fr-marker');
        var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
        var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
        var changeWrapElem = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
        var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>'); // Hide the element if show change button is disabled

        if (!editor.opts.showChangesEnabled) {
          deletedCntnt.addClass('fr-track-hide');
        }

        $img.data('tracking-img', true);

        if ($(node).data('tracking') || parentTracking.length) {
          $(marker).replaceWith(deletedCntnt);
          $(deletedCntnt).append($img);
          editor.markers.remove();
        } else {
          $(marker).replaceWith(changeWrapElem);
          $(changeWrapElem).prepend(deletedCntnt);
          $(deletedCntnt).append($img);
          editor.markers.remove();
          editor.track_changes.pushChange(changeId);
        }
      }
    });
    editor.events.on('commands.before', function (e) {
      if (!editor.opts.trackChangesEnabled) {
        return true;
      } // Commands to filter while calling wrapChange method


      var cmdArray = ['change', 'applyAll', 'applyLast', 'removeLast', 'showChanges', 'trackChanges', 'moreTrackChanges', 'undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'];
      var styleArray = ['applytextColor', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'applybackgroundColor', 'inlineClass', 'inlineStyle', 'alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'];

      if (!cmdArray.filter(function (cmd) {
        return cmd === e;
      }).length && !styleArray.filter(function (cmd) {
        return cmd === e;
      }).length) {
        if (FE.COMMANDS[e] && (FE.COMMANDS[e].hasOwnProperty('type') && FE.COMMANDS[e].type === 'dropdown' || FE.COMMANDS[e].more_btn || FE.COMMANDS[e].popup)) {
          if (e != 'insertImage' && e != 'insertFile') return;
        } else if (e === 'clearFormatting') {
          if (editor.opts.trackChangesEnabled) {
            (function () {
              lastBlocks = editor.selection.blocks();
              var unIdentifiedBlocks = [];
              var currentIndex = 0;

              for (var i = 0; i < lastBlocks.length; i++) {
                currentIndex = currentIndex > i ? currentIndex : i;
                var block = $(lastBlocks[i]);

                if (block.is('li')) {
                  var siblingLi = block.siblings('li');
                  siblingLi.each(function (_, item) {
                    if ($(item).find('li').length) {
                      unIdentifiedBlocks.push({
                        index: currentIndex,
                        item: item
                      });
                      currentIndex = currentIndex + 1;
                    }
                  });
                }

                lastDeletedNode[i] = $("<span>".concat(block.get(0).innerHTML, "</span>"));
              }

              for (var _i2 = 0, _unIdentifiedBlocks = unIdentifiedBlocks; _i2 < _unIdentifiedBlocks.length; _i2++) {
                var unIdentifiedBlock = _unIdentifiedBlocks[_i2];
                var index = unIdentifiedBlock.index;
                var newItem = unIdentifiedBlock.item;
                var newNode = $($(newItem).get(0).outerHTML);
                newNode.find('ul').remove();
                newNode.find('ol').remove();
                lastDeletedNode = [].concat(_toConsumableArray(lastDeletedNode.slice(0, index + 1)), [// inserted item
                $("<span>".concat(newNode.get(0).innerHTML, "</span>"))], _toConsumableArray(lastDeletedNode.slice(index + 1)));
                lastBlocks = [].concat(_toConsumableArray(lastBlocks.slice(0, index + 1)), [// inserted item
                newItem], _toConsumableArray(lastBlocks.slice(index + 1)));
              }
            })();
          }

          return;
        }

        wrapChange();
      } else if (styleArray.filter(function (cmd) {
        return cmd === e;
      }).length && e !== 'paragraphFormat' && e !== 'paragraphStyle' && e !== 'lineHeight') {
        //Track changes sub-toolbar disable until any changes.
        wrapFormat(e);
      } else if (e === 'paragraphFormat' || e === 'paragraphStyle' || e === 'lineHeight') {
        editor.selection.save();
        var startNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0);
        var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
        var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
        var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
        var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false" style="display:none"></span>');
        var txt = startNode.parentNode.cloneNode(true);
        var child = txt.childNodes;

        for (var i = 0; i < child.length;) {
          if (child[i].className && child[i].className === 'fr-marker') {
            child[i].remove();
          } else {
            i++;
          }
        }

        $(deletedCntnt).append(txt);
        $(span).append(deletedCntnt);
        $(startNode.parentNode).after($('<p></p>'));
        $(startNode.parentNode.nextSibling).append(span);
        span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
        $(startNode.parentNode.nextSibling).after($('<p></p>'));
        $(startNode.parentNode.nextSibling.nextSibling).append(span);
        span.append(startNode.parentNode);
        editor.track_changes.pushChange(changeId);
        editor.selection.restore();
      }
    }, true);
    editor.events.on('commands.after', function (e) {
      if (!editor.opts.trackChangesEnabled) {
        return true;
      }

      if (['undo', 'redo'].indexOf(e) >= 0) {
        _updatePendingChanges();
      } else if (e == 'clearFormatting') {
        if (editor.opts.trackChangesEnabled) {
          var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);

          for (var i in lastBlocks) {
            var block = $(lastBlocks[i]);

            if (lastDeletedNode[i]) {
              addClearFormatting(block, lastDeletedNode[i], changeId);
              lastDeletedNode[i] = null;
              lastDeletedText[i] = null;
            }
          }

          editor.track_changes.pushChange(changeId);
          lastDeletedNode = [];
          lastBlocks = null;
        }
      }
    }, true);
    editor.events.on('quickInsert.commands.before', function (e) {
      if (editor.opts.trackChangesEnabled) {
        wrapChange(e);
      }
    }); // Update pending changes list on undo/redo

    function _updatePendingChanges() {
      var allPendingChanges = editor.$el.find('[data-tracking=true]');
      pendingChanges.splice(0, pendingChanges.length);

      for (var i = 0; i < allPendingChanges.length; i++) {
        var trackingId = $(allPendingChanges.get(i)).data('track-id');
        pendingChanges[trackingId.slice(trackingId.lastIndexOf('-') + 1)] = trackingId;
      }
    } // Handle enable/disable tracking


    function toggleTracking() {
      if (editor.opts.trackChangesEnabled && editor.html.get(true, true).indexOf("data-tracking") > -1 || editor.opts.trackChangesEnabled && editor.$el.find('[data-tracking=true]').length > 0) {
        alert('Your editor has pending changes. Please resolve them before turning off Track Changes in the toolbar.');
        return;
      }

      editor.commands.moreTrackChanges();
      editor.opts.trackChangesEnabled = !editor.opts.trackChangesEnabled; //Disable showchange on disable track changes option

      if (!editor.opts.trackChangesEnabled) {
        editor.opts.showChangesEnabled = false;
      }
    } // update changes stack for tracking


    function pushChange(changeId) {
      pendingChanges.push(changeId);
    } //Track delete content with delete button


    function insertChangeAt(index, changeId) {
      pendingChanges = [].concat(_toConsumableArray(pendingChanges.slice(0, index)), [// inserted item
      changeId], _toConsumableArray(pendingChanges.slice(index)));
    } // returs last change from the stack


    function popChange() {
      return pendingChanges.pop();
    } // Returns changes stack tracked


    function getPendingChanges() {
      return pendingChanges;
    } // Wrapping changed elements with properties to track 


    function wrapChange(e) {
      var isBackSpace = e && e.keyCode == 8 ? true : false;
      var isEnter = e && e.keyCode == 13;
      var isDelete = e && e.keyCode == 46 ? true : false;

      if (editor.opts.trackChangesEnabled) {
        // Restore selection while applying style on selected content
        editor.selection.restore();

        if (e && e.composing) {
          editor.selection.save();
          editor.selection.ranges()[0].collapse(false);
        }

        var range = editor.selection.ranges(0);
        var node = range.startContainer;
        var parentTracking = $(node).parentsUntil(editor.$el, '[data-tracking=true]');

        if ($(node).data('tracking') && isBackSpace) {
          // https://github.com/froala-labs/froala-editor-js-2/issues/3916
          // clear selection only if the there is no previousSibling or previousSibling is not image
          // on backspace it loses selection in case of image tag
          editor.markers.insert();
          var marker = editor.$el.find('.fr-marker');

          if (!marker[0].previousSibling || marker[0].previousSibling.tagName !== 'IMG') {
            editor.selection.clear();
          }

          $(marker).remove();
          return;
        }

        if (!parentTracking.length || node.tagName == "TD" || isEnter) {
          // if we are just adding/remove texts without selection
          if (editor.selection.isCollapsed()) {
            editor.markers.insert();

            var _marker = editor.$el.find('.fr-marker');

            if (e && e.composing) _marker = $(_marker[1]);
            if (!_marker.length) return;
            var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
            var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : ''; //Retaining the deleted text from the element and then appending the final text into deletedCotent,
            // and applying styling with $ChangeWrapElem

            if (isBackSpace || isDelete) {
              if (isBackSpace) {
                // https://github.com/froala-labs/froala-editor-js-2/issues/3916
                // if previous sibling is node containing lastChild as image then return, let the default marker play the role and dont add tracking span
                if (!(_marker[0].previousSibling && _marker[0].previousSibling.nodeType === Node.ELEMENT_NODE && _marker[0].previousSibling.lastChild && _marker[0].previousSibling.lastChild.nodeType === Node.ELEMENT_NODE && _marker[0].previousSibling.lastChild.tagName === 'IMG')) {
                  // Find previsous sibling in case of Backspace
                  while ($(_marker[0].previousSibling).data('tracking')) {
                    _marker.insertBefore(_marker.prev());
                  }

                  if ($(_marker[0].previousSibling).find('[data-tracking=true]').length) {
                    _marker.insertBefore($(_marker[0].previousSibling).find('[data-tracking=true]').eq(0));
                  }
                }
              } else {
                if ($(node).data('tracking')) {
                  if (!node.nextSibling) {
                    // remove image on delete button, if it is already being tracked
                    if (_marker[0].nextSibling && _marker[0].nextSibling.tagName === 'IMG') {
                      _marker[0].nextSibling.remove();
                    }

                    return;
                  }

                  _marker.insertBefore(node.nextSibling);

                  deepDeleteTracking(_marker);
                } else {
                  deepDeleteTracking(_marker);
                }
              }

              var totalText = _marker[0] && _marker[0].previousSibling ? _marker[0].previousSibling.nodeValue : '';
              var retainedText = totalText && totalText.slice(0, -(e.selectionLength ? e.selectionLength : 1));

              if (isDelete) {
                // if there is next sibling with null node value, put cursor inside it
                if (_marker[0].nextSibling && _marker[0].nextSibling.tagName !== 'SPAN' && _marker[0].nextSibling.nodeValue === null && _marker[0].nextSibling.firstChild) {
                  _marker[0].nextSibling.firstChild.before(_marker[0]);
                }

                totalText = _marker[0].nextSibling ? _marker[0].nextSibling.nodeValue : ' ';
                retainedText = totalText && totalText.slice(1);
              } // this is working only in paste of content


              if (isDelete && _marker[0].nextSibling && _marker[0].nextSibling.id === 'isPasted') {
                totalText = _marker[0].nextSibling ? _marker[0].nextSibling.textContent : ' ';
                retainedText = totalText && totalText.slice(1);
              } else if (isBackSpace && _marker[0].previousSibling && _marker[0].previousSibling.id === 'isPasted') {
                totalText = _marker[0].previousSibling ? _marker[0].previousSibling.textContent : ' ';
                retainedText = totalText && totalText.slice(0, -(e.selectionLength ? e.selectionLength : 1));
              }

              var changeWrapElem = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>")); // Contenteditable of deleted content for IOS, is handled separately in keyUP

              var deletedCntnt = $("<span data-tracking-deleted=\"true\" class=\"fr-tracking-deleted\" ".concat(editor.helpers.isIOS() ? '' : 'contenteditable="false"', "></span>")); // Hide the element if show change button is disabled

              if (!editor.opts.showChangesEnabled) {
                // Separate css for mobile hide feature
                editor.helpers.isMobile() ? deletedCntnt.addClass('fr-track-hide-mobile') : deletedCntnt.addClass('fr-track-hide');
              }

              var deletedText;
              var deleteMarker = false;
              var isHr = false;

              if (isBackSpace) {
                try {
                  var previousSibling = _marker[0] && _marker[0].previousSibling; // tracking Font Awesome in backspace 

                  if (_marker[0] && _marker[0].previousElementSibling && _marker[0].previousElementSibling.tagName === 'I' && !totalText) {
                    deletedText = _marker[0].previousElementSibling;
                  } //tracking Emoticons for backspace


                  if (previousSibling && previousSibling.nodeType === 3 && previousSibling.parentNode.tagName !== 'SPAN' && previousSibling.previousSibling && previousSibling.previousSibling.tagName === 'SPAN' && previousSibling.nodeValue === ' ') {
                    deletedText = previousSibling.previousSibling;
                  } else if (previousSibling && previousSibling.parentNode.tagName === 'SPAN' && $(previousSibling.parentNode).find('.fr-emoticon').length > 0) {
                    deletedText = previousSibling.parentNode;
                    deleteMarker = true;
                  } else if (previousSibling && (previousSibling.tagName === 'SPAN' && previousSibling.id !== 'isPasted' || previousSibling.tagName === 'HR')) {
                    deletedText = previousSibling;
                  } //tracking HR for backspace
                  else if ($(_marker).parent().prev().is('hr')) {
                    deletedText = $(_marker).parent().prev().get(0);
                    isHr = true;
                    deleteMarker = true;
                  } else if (previousSibling && previousSibling.tagName === 'IMG') {
                    deletedText = previousSibling;
                    $(changeWrapElem).prepend("".concat(FE.MARKERS));
                    $(changeWrapElem).append("".concat(FE.MARKERS));
                  } // check if our marker cursor is before any tag and we pressed backspace so the cursor must go to next element.


                  if (editor.helpers.isMobile() && _marker[0] && !deletedText && !totalText && !retainedText) {
                    return;
                  }

                  if (deleteMarker) {
                    $(_marker[0].parentNode).after(changeWrapElem);

                    if (isHr) {
                      $(_marker).parent().remove();
                    } else {
                      $(_marker).remove();
                    }
                  } else if (_marker[0]) {
                    e.composing ? $(_marker).after(changeWrapElem) : $(_marker).before(changeWrapElem);
                  } else {
                    $(nextSiblng).before(changeWrapElem);
                  }
                } catch (e) {
                  if (nextSiblng) $(nextSiblng).before(changeWrapElem);
                }
              } else if (isDelete) {
                var markerNextSibling = _marker[0].nextSibling; // tracking Font Awesome in delete 

                if (_marker[0].nextElementSibling && _marker[0].nextElementSibling.tagName === 'I' && !_marker[0].nextSibling.nodeValue) {
                  deletedText = _marker[0].nextElementSibling;
                } //tracking Emoticons for delete key
                else if (markerNextSibling && markerNextSibling.nodeType === 3 && markerNextSibling.parentNode.tagName !== 'SPAN' && markerNextSibling.nextSibling && markerNextSibling.nextSibling.tagName === 'SPAN' && markerNextSibling.nodeValue === ' ') {
                  deletedText = markerNextSibling.nextSibling;
                } else if (markerNextSibling && markerNextSibling.parentNode.tagName === 'SPAN' && $(markerNextSibling.parentNode).find('.fr-emoticon').length > 0) {
                  deletedText = markerNextSibling.parentNode;
                  deleteMarker = true;
                } else if (markerNextSibling && markerNextSibling.tagName === 'SPAN' && _marker[0].nextSibling && _marker[0].nextSibling.id !== 'isPasted') {
                  deletedText = markerNextSibling;
                } else if (markerNextSibling && markerNextSibling.tagName === 'IMG') {
                  deletedText = markerNextSibling;
                  $(changeWrapElem).prepend("".concat(FE.MARKERS));
                  $(changeWrapElem).append("".concat(FE.MARKERS));
                }

                if (deleteMarker) {
                  $(_marker[0].parentNode).before(changeWrapElem);
                  $(_marker).remove();
                } else {
                  $(_marker).after(changeWrapElem);
                }
              } // Deleted element is tracked here and
              // Inserted back in DOM in KeyUp, for mobile devices.


              if (e.composing) {
                trackArr.push({
                  span: changeWrapElem,
                  "delete": deletedCntnt
                });
              } else {
                editor.helpers.isIOS() && trackArr.push({
                  "delete": deletedCntnt
                });
                $(changeWrapElem).prepend(deletedCntnt);
              }

              if (!deletedText) {
                deletedText = totalText && totalText.replace(retainedText, '');

                if (editor.helpers.isMobile() && prevNodeValue && !e.composing) {
                  var focusNode = editor.selection.get().focusNode;
                  var focusOffset = editor.selection.get().focusOffset;
                  var selDelLength = 1;

                  if (prevNode && focusNode && prevNode.isSameNode(focusNode)) {
                    selDelLength = prevOffset - focusOffset;
                  }

                  deletedText = prevNodeValue.replace(/\u00a0/g, ' ').replace(totalText.replace(/\u00a0/g, ' '), '').slice(0, selDelLength);
                }
              }

              if (deletedText) {
                if (deleteMarker) {
                  $(deletedCntnt).append($($(deletedText).get(0).outerHTML));
                  editor.markers.insert();
                } else {
                  $(deletedCntnt).append(deletedText);
                }
              }

              if (deletedText && deletedText.length == 0) {
                return;
              }

              if (editor.browser.msie && isBackSpace) {
                $(changeWrapElem).prepend("".concat(FE.MARKERS));
                $(changeWrapElem).append("".concat(FE.MARKERS));
              } // Allow empty string for wrapping (Adjacent tags not having space)
              // Example: <p> Myself-<strong>John</strong> <p>


              if (isBackSpace && (retainedText || retainedText === "") && _marker[0].previousSibling) {
                _marker[0].previousSibling.nodeValue = retainedText;
              } else if (isDelete) {
                $(changeWrapElem).append("".concat(FE.MARKERS));
                _marker[0].nextSibling.nodeValue = retainedText;
              }
            } else {
              var newInsert = FE.INVISIBLE_SPACE;

              if (e && editor.helpers.isMobile()) {
                newInsert = _marker[0] && _marker[0].previousSibling && _marker[0].previousSibling.nodeValue ? _marker[0].previousSibling.nodeValue.slice(-1) : FE.INVISIBLE_SPACE;

                if (newInsert && _marker[0] && _marker[0].previousSibling && _marker[0].previousSibling.nodeValue) {
                  _marker[0].previousSibling.nodeValue = _marker[0].previousSibling.nodeValue.slice(0, -1);
                } else if (_marker[0] && !_marker[0].previousSibling && !_marker[0].nextSibling && newInsert === FE.INVISIBLE_SPACE) {
                  newInsert = editor.selection.get().focusNode.nodeValue.slice(prevOffset, editor.selection.get().focusOffset);
                  editor.selection.get().focusNode.nodeValue = editor.selection.get().focusNode.nodeValue.slice(editor.selection.get().focusOffset);
                }
              }

              if (isEnter) {
                if (_marker.parent().parent().is('li')) {
                  return;
                }

                var newP = $('<p></p>'); // handled console error. if there is no closest 'p' then don't do it

                if (_marker.closest('p').length > 0) {
                  _marker.closest('p').after(newP);

                  newP.append(_marker);
                  editor.markers.remove();
                  setTimeout(function () {
                    // https://github.com/froala-labs/froala-editor-js-2/issues/3813
                    if (newP.prev().text() === String.fromCharCode(8203) || newP.prev().text() === '') {
                      newP.prev().remove();
                    }

                    editor.selection.setAfter(newP[0]);
                  }, 1);
                }

                return;
              } else {
                // https://github.com/froala-labs/froala-editor-js-2/issues/3813
                if (_marker[0].previousSibling && _marker[0].previousSibling.tagName === 'BR') {
                  _marker[0].previousSibling.remove();
                }

                _marker.replaceWith("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, ">").concat(newInsert + FE.MARKERS, "</span>"));
              }
            }

            editor.selection.restore();
            editor.track_changes.pushChange(changeId);
          } else {
            // if we are adding/removing new text with selection
            editor.selection.save();
            var startNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0);
            var endNode = editor.$el.find('.fr-marker[data-type="false"]').length && editor.$el.find('.fr-marker[data-type="false"]').get(0);

            if ($(startNode).parent().hasClass('fr-emoticon')) {
              $(startNode).parent().before(startNode);
            } // Corrected markers for processing selected text
            // Start node marker should be before end node marker


            if ($(startNode).isAfter($(endNode))) {
              var temp = startNode;
              startNode = endNode;
              endNode = temp;
            }

            processNode(startNode, endNode, e && e.deletion);
            editor.selection.restore();
          }

          if (editor.helpers.isMobile() && prevNodeValue) {
            editor.markers.remove();
          }
        }
      }
    } //Check marker in tracking


    function deepDeleteTracking(marker) {
      if ($(marker[0].nextSibling).data('tracking')) {
        while ($(marker[0].nextSibling).data('tracking')) {
          if ($(marker[0].previousElementSibling).find('[data-tracking-deleted=true]').length > 0 && $(marker[0].nextElementSibling).find('[data-tracking-deleted=true]').length > 0 && !$(marker[0].previousSibling).data('tracking')) {
            break;
          }

          $(marker).insertAfter(marker.next());
        }

        marker.insertBefore(marker[0].previousSibling);
      }
    }

    function processNode(start_node, end_node) {
      var handleMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // No start node.
      if (!start_node) {
        return;
      } // start_node & end_node are same, then return from loop.


      if (start_node.isSameNode(end_node) && $(start_node).hasClass('fr-marker')) {
        return;
      } // Skip comments.


      while (start_node.nodeType === Node.COMMENT_NODE) {
        start_node = start_node.nextSibling;
      } //check parent of start node is table.


      if ($(start_node).parent().is('table') && $(start_node).parent().next().text().length !== 0) {
        processNode($(start_node).parent().next()[0], end_node, handleMobile);
      }

      if (start_node.tagName === 'TD' && start_node.childNodes.length === 1 && start_node.childNodes[0].tagName === 'BR') {
        return;
      } // If we are in a block process starting with the first child.


      if (editor.node.isBlock(start_node) && start_node.tagName !== 'HR') {
        if (editor.node.hasClass(start_node.firstChild, 'fr-marker')) {
          processNode(start_node.firstChild.nextSibling, end_node, handleMobile);
        } else {
          processNode(start_node.firstChild, end_node, handleMobile);
        }

        return false;
      } // Remove BR from td otherwise it increase height of cell.


      if (start_node.tagName === 'BR' && start_node.parentElement.tagName === "TD") {
        var ele = start_node.parentElement.nextElementSibling;
        $(start_node).remove();
        processNode(ele, end_node);
      } // declare tracking element


      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      var deletedCntnt = $("<span data-tracking-deleted=\"true\" class=\"fr-tracking-deleted\" ".concat(editor.helpers.isIOS() ? '' : 'contenteditable="false"', "></span>")); // Hide the element if show change button is disabled

      if (!editor.opts.showChangesEnabled) {
        // Separate css for mobile hide feature
        editor.helpers.isMobile() ? deletedCntnt.addClass('fr-track-hide-mobile') : deletedCntnt.addClass('fr-track-hide');
      }

      var node = start_node; // add track span to node position

      $(start_node).before(span); // add changeId to array to track

      editor.track_changes.pushChange(changeId); // check if we have correct node, if it has marker then move to sibling

      while (node) {
        if ($(node).hasClass('fr-marker')) {
          node = node.nextSibling;
        } else {
          break;
        }
      }

      var br = false; // Search while there is a next node.
      // Next node is not marker.
      // Next node does not contain marker.
      // Next node is not an inner list.
      // Inner node is not a tracking node.

      while (node && !br && !$(node).hasClass('fr-marker') && !$(node).is('[data-track-id]') && $(node).find('fr-marker').length === 0 && node.tagName !== 'UL' && node.tagName !== 'OL') {
        var tmp = node; // Accept all for image needs data-tracking-img="true"

        if (node.tagName === 'IMG') {
          $(node).data('tracking-img', 'true');
        }

        if (editor.node.isBlock(node) && start_node.tagName !== 'HR') {
          processNode(node.firstChild, end_node, handleMobile);
          return false;
        }

        if (node) {
          // in case the marker is in childnodes
          var child = node.childNodes;

          for (var i = 0; i < child.length; i++) {
            if (child[i].className && child[i].className === 'fr-marker') {
              br = true; // process child node

              processNode(node.firstChild, end_node, handleMobile);
              break;
            }
          }
        } // if force break then don't go to next sibling


        if (!br) {
          node = node.nextSibling;
        } else {
          // if child node is being processed skip this node
          continue;
        } // append node to deleted text span


        $(deletedCntnt).append(tmp);
      }

      if (node && (node.tagName === 'UL' || node.tagName === 'OL')) {
        processNode(node, end_node, handleMobile);
      } // Deleted element is tracked here and
      // Inserted back in DOM in KeyUp, for mobile devices.


      if (handleMobile) {
        trackArr.push({
          span: span,
          "delete": deletedCntnt
        });
      } else {
        editor.helpers.isIOS() && trackArr.push({
          "delete": deletedCntnt
        });
        $(span).prepend(deletedCntnt);
      }

      if (editor.browser.msie) {
        $(span).prepend("".concat(FE.INVISIBLE_SPACE + FE.MARKERS));
        $(span).append("".concat(FE.INVISIBLE_SPACE + FE.MARKERS));
      } else {
        $(span).prepend("".concat(FE.INVISIBLE_SPACE));
        $(span).append("".concat(FE.INVISIBLE_SPACE + FE.MARKERS));
      } // If start node position is not same as end node position then repeat for parent 'p' sibling.


      if (!node && !start_node.isSameNode(end_node)) {
        var p_node = span.get(0).parentNode;

        while (p_node && !p_node.nextSibling && !editor.node.isElement(p_node)) {
          p_node = p_node.parentNode;
        }

        if (p_node) {
          var sibling = p_node.nextSibling;

          if (sibling) {
            // Parent sibling is block then look next.
            if (!editor.node.isBlock(sibling)) {
              processNode(sibling, end_node, handleMobile);
            } else if (sibling.tagName === 'HR') {
              processNode(sibling.nextSibling, end_node, handleMobile);
            } else {
              if (editor.browser.mozilla && p_node.tagName === 'LI' && p_node.lastChild.tagName === 'SPAN' && $(p_node.lastChild).hasClass('fr-marker')) {
                p_node.lastChild.remove();
              }

              processNode(sibling.firstChild, end_node, handleMobile);
            }
          }
        }
      }
    } // method to handle style related changes on node


    function wrapFormat(cmd) {
      if (editor.opts.trackChangesEnabled) {
        editor.selection.restore(); // Restore selection while applying style on selected content

        var range = editor.selection.ranges(0);
        var node = range.startContainer;
        var parentTracking = $(node).parentsUntil(editor.$el, '[data-tracking=true]');

        if ($(node).data('tracking')) {
          return;
        }

        if (!parentTracking.length) {
          // if we are just adding/remove texts without selection
          if (!editor.selection.isCollapsed() && cmd != 'quote') {
            // if we are adding/removing new text with selection
            editor.selection.save();
            var startNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0);
            var endNode = editor.$el.find('.fr-marker[data-type="false"]').length && editor.$el.find('.fr-marker[data-type="false"]').get(0);
            processStyle(startNode, endNode);
            var tempNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0); //Find parentnode for clear formatting.

            var tempParentNode = tempNode.parentNode;

            if (tempParentNode && tempParentNode.tagName === 'A' && tempParentNode.firstChild && tempParentNode.firstChild.tagName === 'SPAN' && tempParentNode.firstChild.childNodes.length > 2 && tempParentNode.firstChild.childNodes[3].tagName === 'STRONG') {
              $(tempParentNode.firstChild.childNodes[3].firstChild).before(tempNode);
            } else {
              var spanTemp = tempNode.previousSibling;
              var _node = spanTemp.firstChild;

              while (_node && _node.tagName !== 'SPAN') {
                _node = _node.nextSibling;
              }

              $(_node).after(tempNode);
            }

            editor.selection.restore();
          }
        }
      }
    }

    function processStyle(start_node, end_node, changeId) {
      // No start node.
      if (!start_node) {
        return;
      }

      if ($(start_node).html() === '<br>' && $(start_node).parent().is('td')) {
        return;
      } //check parent of start node is table.


      if ($(start_node).parent().is('table') && $(start_node).parent().next().text().length !== 0) {
        processStyle($(start_node).parent().next()[0], end_node, changeId);
      }

      if ($(start_node).is('br') && $(start_node).parent().length && $(start_node).parent().is('td') && $(start_node).parent().text().length === 0) {
        return;
      }

      if (!changeId) {
        changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
        editor.track_changes.pushChange(changeId);
      } // Skip comments.


      while (start_node.nodeType === Node.COMMENT_NODE) {
        start_node = start_node.nextSibling;
      } // If we are in a block process starting with the first child.


      if (editor.node.isBlock(start_node) && start_node.tagName !== 'HR') {
        if (editor.node.hasClass(start_node.firstChild, 'fr-marker')) {
          processStyle(start_node.firstChild.nextSibling, end_node, changeId);
        } else {
          processStyle(start_node.firstChild, end_node, changeId);
        }

        return false;
      } // declare tracking element


      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false" style="display:none"></span>');
      var node = start_node; // add track span to node position

      $(start_node).before(span); // check if we have correct node, if it has marker then move to sibling

      while (node) {
        if ($(node).hasClass('fr-marker')) {
          node = node.nextSibling;
        } else {
          break;
        }
      }

      var br = false; // Search while there is a next node.
      // Next node is not marker.
      // Next node does not contain marker.
      // Next node is not an inner list.

      while (node && !br && !$(node).hasClass('fr-marker') && $(node).find('fr-marker').length === 0 && node.tagName !== 'UL' && node.tagName !== 'OL') {
        var tmp = node;

        if (editor.node.isBlock(node) && start_node.tagName !== 'HR') {
          processStyle(node.firstChild, end_node, changeId);
          return false;
        }

        if (node) {
          // in case the marker is in childnodes
          var child = node.childNodes;

          for (var i = 0; i < child.length; i++) {
            if (child[i].className && child[i].className === 'fr-marker') {
              br = true; // process child node

              processStyle(node.firstChild, end_node, changeId);
              break;
            }
          }
        } // if force break then don't go to next sibling


        if (!br) {
          node = node.nextSibling;
        } else {
          // if child node is being processed skip this node
          continue;
        } // append node to deleted text span


        $(deletedCntnt).append(tmp.cloneNode(true));
        $(span).append(tmp);
      }

      if (node && (node.tagName === 'UL' || node.tagName === 'OL')) {
        processStyle(node, end_node, changeId);
      }

      if ($(node).hasClass('fr-marker')) {
        $(span).append(node);
      } // add delete span to track span


      $(span).prepend(deletedCntnt);
      $(span).prepend("".concat(FE.INVISIBLE_SPACE));
      $(span).append("".concat(FE.INVISIBLE_SPACE)); // If start node position is not same as end node position then repeat for parent 'p' sibling.

      if (!node && !start_node.isSameNode(end_node)) {
        var p_node = span.get(0).parentNode;

        while (p_node && !p_node.nextSibling && !editor.node.isElement(p_node)) {
          p_node = p_node.parentNode;
        }

        if (p_node) {
          var sibling = p_node.nextSibling;

          if (sibling) {
            // Parent sibling is block then look next.
            if (!editor.node.isBlock(sibling)) {
              processStyle(sibling, end_node, changeId);
            } else if (sibling.tagName === 'HR') {
              processStyle(sibling.nextSibling, end_node, changeId);
            } else {
              processStyle(sibling.firstChild, end_node, changeId);
            }
          }
        }
      }
    } //This function call on when editor has no text i.e empty editor.


    function pasteInEmptyEdior(clean_html) {
      var wrapElem = editor.$el.find('.fr-highlight-change');
      $(wrapElem)[0].style.display = 'block';
      $(wrapElem)[0].innerHTML = clean_html;
    } //This function call on when editor has some text i.e editor is not empty.


    function pasteInEdior(clean_html) {
      var marker = editor.$el.find('.fr-marker');
      $(marker)[0].outerHTML = clean_html;
      editor.markers.remove();
    } //Track text is delete or not.


    function wrapInDelete(item) {
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');

      if (!editor.opts.showChangesEnabled) {
        // Separate css for mobile hide feature
        editor.helpers.isMobile() ? deletedCntnt.addClass('fr-track-hide-mobile') : deletedCntnt.addClass('fr-track-hide');
      }

      deletedCntnt.append(item);
      return deletedCntnt;
    } //Track url is delete or not.


    function wrapLinkInTracking(item, changeIndex) {
      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      item.before(span);
      span.append(item);
      editor.track_changes.insertChangeAt(changeIndex - 1, changeId);
      return span;
    } // used for HR wraping for track changes


    function wrapInTracking(item, extraClass) {
      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      if (extraClass) span.addClass(extraClass);
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');

      if (!editor.opts.showChangesEnabled) {
        deletedCntnt.addClass('fr-track-hide');
      }

      item.before(span);
      span.append(item);
      editor.track_changes.pushChange(changeId);
      return span;
    } // function to handle replacement of image, videos


    function replaceSpecialItem($item) {
      editor.selection.setBefore($item.get(0));
      editor.selection.setAfter($item.get(0));
      var startNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0);
      var endNode = editor.$el.find('.fr-marker[data-type="false"]').length && editor.$el.find('.fr-marker[data-type="false"]').get(0);
      processStyle(startNode, endNode);
    } // function to handle removed image, videos


    function removeSpecialItem($item) {
      editor.selection.setBefore($item.get(0));
      editor.selection.setAfter($item.get(0));
      var startNode = editor.$el.find('.fr-marker[data-type="true"]').length && editor.$el.find('.fr-marker[data-type="true"]').get(0);
      var endNode = editor.$el.find('.fr-marker[data-type="false"]').length && editor.$el.find('.fr-marker[data-type="false"]').get(0);
      processNode(startNode, endNode);
    } // function to handle removed table


    function removedTable($table) {
      var isFlag = false;
      $table.find('[data-tracking=true]').each(function () {
        var b = this.innerText.replace(/\u200B/g, '');

        if (b.length > 0) {
          isFlag = true;
          return;
        }
      });

      if (isFlag) {
        alert('Your table has pending changes. Please resolve them before remove table.');
        return;
      }

      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var span = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');
      $table.before(span);
      $table.find('tr').find('> td').each(function () {
        var spanTd = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
        var deletedCntntTd = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');
        var $td = $(this);
        var tdText = $td[0].innerText;
        $(deletedCntntTd)[0].innerText = tdText;
        $td[0].innerText = '';
        spanTd.prepend(deletedCntntTd);
        $td.prepend(spanTd);
      });
      deletedCntnt.append($table);
      span.append(deletedCntnt);
      editor.track_changes.pushChange(changeId);
    } // function to handle quotes


    function addQuote($quote) {
      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var divDelete = $("<div data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></div>"));
      var divChange = $("<div data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></div>"));
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');

      if (!editor.opts.showChangesEnabled) {
        deletedCntnt.addClass('fr-track-hide');
      }

      $quote.before(divChange);
      $quote.before(divDelete);
      var beforeQuote = $quote.get(0).innerHTML;
      deletedCntnt.append(beforeQuote);
      divDelete.append(deletedCntnt);
      divChange.append($quote);
      divChange.find('[data-tracking="true"]').each(function (index, item) {
        $(item).children().eq(0).insertBefore($(item));
        $(item).remove();
      });
      editor.track_changes.pushChange(changeId);
    } // clear any fomatting applied on any part of text


    function addClearFormatting(block, lastDeletedNode, changeId) {
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var spanChange = $("<span data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></span>"));
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');

      if (!editor.opts.showChangesEnabled) {
        deletedCntnt.addClass('fr-track-hide');
      }

      deletedCntnt.append(lastDeletedNode.get(0).innerHTML);
      spanChange.append(deletedCntnt);
      var changes = block.get(0).innerHTML;
      block.html('');
      block.append(spanChange);
      spanChange.append(changes);
    } // This funcion remove quote on decrease quote button


    function removeQuote($quote, index) {
      if (index > 0) {
        return;
      }

      var changeId = "pending-".concat(editor.id, "-").concat(editor.track_changes.getPendingChanges().length);
      var changeHighlightClass = editor.opts.showChangesEnabled ? 'class="fr-highlight-change"' : '';
      var divDelete = $("<div data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></div>"));
      var divChange = $("<div data-tracking=\"true\" data-track-id=\"".concat(changeId, "\" ").concat(changeHighlightClass, "></div>"));
      var deletedCntnt = $('<span data-tracking-deleted="true" class="fr-tracking-deleted" contenteditable="false"></span>');

      if (!editor.opts.showChangesEnabled) {
        deletedCntnt.addClass('fr-track-hide');
      }

      $quote.before(divChange);
      $quote.before(divDelete);
      var withoutBlockQuote = $quote.find('blockQuote').eq(0).html();

      if (!withoutBlockQuote) {
        withoutBlockQuote = $quote.html();
      }

      deletedCntnt.append($quote);
      divDelete.append(deletedCntnt);
      divChange.append(withoutBlockQuote);
      divChange.find('[data-tracking="true"]').each(function (index, item) {
        $(item).children().eq(0).insertBefore($(item));
        $(item).remove();
      });
      editor.track_changes.pushChange(changeId);
    } // Function to toggle the visibility of deleted content


    function updateVisibility(deletedElements, showChanges) {
      for (var i = 0; i < deletedElements.length; i++) {
        if (showChanges) {
          $(deletedElements.get(i)).removeClass('fr-track-hide');
          $(deletedElements.get(i)).removeClass('fr-track-hide-mobile');
        } else {
          editor.helpers.isMobile() ? $(deletedElements.get(i)).addClass('fr-track-hide-mobile') : $(deletedElements.get(i)).addClass('fr-track-hide');
        }
      }
    } // Handle show/hide tracked changes


    function showChanges() {
      editor.opts.showChangesEnabled = !editor.opts.showChangesEnabled;
      var deletedElements = editor.$el.find('.fr-tracking-deleted'); // For deleted elements , toggle visibility

      updateVisibility(deletedElements, editor.opts.showChangesEnabled);

      if (editor.opts.showChangesEnabled) {
        var changesToHighlight = editor.$el.find('[data-tracking=true]').not('.fr-highlight-change');

        for (var i = 0; i < changesToHighlight.length; i++) {
          $(changesToHighlight.get(i)).addClass('fr-highlight-change');
        }
      } else {
        var _changesToHighlight = editor.$el.find('.fr-highlight-change');

        for (var _i3 = 0; _i3 < _changesToHighlight.length; _i3++) {
          $(_changesToHighlight.get(_i3)).removeClass('fr-highlight-change');
        }
      }
    } //Method use to reset image, video selection and remove empty tag.


    function cleanupSpecial() {
      editor.events.trigger('image.hideResizer');
      editor.events.trigger('video.hideResizer');
      editor.html.cleanEmptyTags(true); // remove tracking property from images on accept/reject changes

      if (editor.helpers.isMobile()) {
        var $trackingImgs = editor.$el.find('img[data-tracking-img]');

        for (var i = 0; i < $trackingImgs.length; i++) {
          var $img = $($trackingImgs.get(i));

          if (!$img.parent() || !$img.parent().data('tracking')) {
            $img.removeData('tracking-img');
          }
        }
      }
    } // Handle accepting all tracked changes


    function acceptAllChanges() {
      while (editor.track_changes.getPendingChanges().length != 0) {
        acceptSingleChange();
      }

      pendingChanges = [];
      clearListTag();
      editor.$el.find('li').each(function () {
        if ($(this).children()[0] && ($(this).children()[0].tagName === "OL" || $(this).children()[0].tagName === "UL")) clearListTag();
      });
    } //Remove all LI tag from DOM 


    function clearListTag() {
      editor.$el.find('li').each(function () {
        var b = this.innerText.replace(/\u200B/g, '');

        if (b.length === 0) {
          this.remove();
        }
      });
    } // Handle reject all tracked changes


    function rejectAllChanges() {
      while (editor.track_changes.getPendingChanges().length != 0) {
        rejectSingleChange();
      }

      pendingChanges = [];
    } // Handle accepting single last tracked change


    function acceptSingleChange() {
      var lastChange = popChange();

      if (lastChange) {
        var $tmpElem = editor.$el.find("[data-track-id=".concat(lastChange, "]"));
        var deleteAnchor;

        if ($tmpElem.length) {
          var parentAnchor = $tmpElem.parent('a');

          if (parentAnchor.length) {
            var anchorNode = $(parentAnchor.get(0).outerHTML); //clones to prevent deleting actual nodes
            // anchorNode.find('.fr-tracking-deleted').remove();

            var anchorText = anchorNode.text();
            var textLength = [].filter.call(anchorText, function (c) {
              return c.charCodeAt(0) !== 8203;
            });

            if (textLength.length === 1) {
              deleteAnchor = parentAnchor;
            }
          }

          for (var j = 0; j < $tmpElem.length; j++) {
            var tmpNode = $tmpElem.get(j);
            var deletedCntnt = $($tmpElem).data('tracking-deleted') ? $($tmpElem) : $(tmpNode).find('[data-tracking-deleted=true]');

            if (deletedCntnt.length) {
              if (deletedCntnt.get(0).remove) {
                deletedCntnt.get(0).remove();
              } else {
                deletedCntnt.get(0).parentNode.removeChild(deletedCntnt.get(0));
              }
            }

            if (!tmpNode.hasAttribute('style')) {
              editor.selection.save();

              if ($(tmpNode).find('IFRAME').length > 0) {
                $(tmpNode).removeData('tracking');
                $(tmpNode).removeData('track-id');
                $(tmpNode).removeClass('fr-highlight-change');
              } else {
                tmpNode.outerHTML = tmpNode.innerHTML;
              }

              editor.selection.restore();
            } else {
              $(tmpNode).removeData('tracking');
              $(tmpNode).removeData('track-id');
              $(tmpNode).removeClass('fr-highlight-change');
            }
          }
        }

        deleteAnchor && deleteAnchor.remove();
      }

      cleanupSpecial();
    } // Handle reject single last tracked change


    function rejectSingleChange() {
      var lastChange = popChange();

      if (lastChange) {
        var $tmpElem = editor.$el.find("[data-track-id=".concat(lastChange, "]"));

        if ($tmpElem.length) {
          editor.selection.save();

          for (var j = $tmpElem.length - 1; j >= 0; j--) {
            var deletedCntnt = $($tmpElem).data('tracking-deleted') ? $($tmpElem) : $($tmpElem.get(j)).find('[data-tracking-deleted=true]');

            if (deletedCntnt.length) {
              if ($($tmpElem).find('IFRAME').length > 0) {
                $($tmpElem).removeData('tracking');
                $($tmpElem).removeData('track-id');
                $($tmpElem).removeClass('fr-highlight-change');
                $($tmpElem).removeClass('fr-tracking-deleted');
                $($tmpElem).removeData('tracking-deleted');
                $($tmpElem).removeAttr('contenteditable');
              } else {
                var deletedTrackId = deletedCntnt.parent('[data-tracking=true]').data('track-id');

                if (deletedTrackId == lastChange) {
                  $($tmpElem.get(j)).find('[data-tracking-deleted=true]').remove(); // 3806-When formatting changes are rejected, the highlighted text duplicates itself 

                  $tmpElem.get(j).outerHTML = deletedCntnt.get(0).innerHTML;
                } else {
                  if ($tmpElem.get(j).remove) {
                    $tmpElem.get(j).remove();
                  } else {
                    $tmpElem.get(j).parentNode.removeChild($tmpElem.get(j));
                  }
                }
              }
            } else {
              if ($tmpElem.get(j).remove) {
                $tmpElem.get(j).remove();
              } else {
                $tmpElem.get(j).parentNode.removeChild($tmpElem.get(j));
              }
            }
          }

          editor.selection.restore();
        }
      }

      cleanupSpecial();
    } // Handle highlighting accept and reject buttons based on pending changes


    function refresh($btn) {
      var trackingEle = editor.$el.find('[data-tracking=true]');
      $btn.toggleClass('fr-disabled', !pendingChanges.length);
      $btn.toggleClass('fr-active', pendingChanges.length).attr('aria-pressed', pendingChanges.length);

      if (!trackingEle.length > 0) {
        $btn.removeClass('fr-active');
        $btn.addClass('fr-disabled');
      }

      var markdown = editor.$tb.find('.fr-command[data-cmd="markdown"]');

      if (markdown && editor.opts.trackChangesEnabled) {
        markdown.addClass('fr-disabled');
      } else if (markdown && !$(".fr-active.fr-popup").length) {
        markdown.removeClass('fr-disabled');
      }

      var showChanges = editor.$tb.find('.fr-command[data-cmd="showChanges"]');

      if (showChanges && editor.opts.trackChangesEnabled) {
        showChanges.removeClass('fr-disabled');
      }
    } // Public methods


    return {
      toggleTracking: toggleTracking,
      pushChange: pushChange,
      insertChangeAt: insertChangeAt,
      popChange: popChange,
      getPendingChanges: getPendingChanges,
      showChanges: showChanges,
      acceptAllChanges: acceptAllChanges,
      rejectAllChanges: rejectAllChanges,
      acceptSingleChange: acceptSingleChange,
      rejectSingleChange: rejectSingleChange,
      refresh: refresh,
      replaceSpecialItem: replaceSpecialItem,
      removeSpecialItem: removeSpecialItem,
      removedTable: removedTable,
      addQuote: addQuote,
      removeQuote: removeQuote,
      wrapInTracking: wrapInTracking,
      wrapInDelete: wrapInDelete,
      wrapLinkInTracking: wrapLinkInTracking,
      pasteInEmptyEdior: pasteInEmptyEdior,
      pasteInEdior: pasteInEdior
    };
  };

  FE.DefineIcon('trackChanges', {
    NAME: 'enable-tracking',
    SVG_KEY: 'trackChanges'
  });
  FE.DefineIcon('showChanges', {
    NAME: 'show-changes',
    SVG_KEY: 'showTrackChanges'
  });
  FE.DefineIcon('applyAll', {
    NAME: 'apply-all',
    SVG_KEY: 'acceptAllChanges'
  });
  FE.DefineIcon('removeAll', {
    NAME: 'remove-all',
    SVG_KEY: 'rejectAllChanges'
  });
  FE.DefineIcon('applyLast', {
    NAME: 'apply-last',
    SVG_KEY: 'acceptSingleChange'
  });
  FE.DefineIcon('removeLast', {
    NAME: 'remove-last',
    SVG_KEY: 'rejectSingleChange'
  });
  FE.RegisterCommand('trackChanges', {
    type: 'button',
    title: 'Enable Track Changes',
    plugin: 'track_changes',
    showOnMobile: true,
    callback: function callback() {
      this.track_changes.toggleTracking();
    },
    refreshAfterCallback: true,
    forcedRefresh: true,
    refresh: function refresh($btn) {
      if ($btn) {
        // https://github.com/froala-labs/froala-editor-js-2/issues/3980
        // if switching between instances of Froala, and trackchanges is enabled but the secondary toolbar is not visible
        // or trackchagnes is not enabled but the secondary toolbar is visible then toggle it
        var tb = this.$tb.find(".fr-more-toolbar[data-name=\"".concat($btn.attr('id'), "\"]"));
        var hasClass = tb.length !== 0 && tb.hasClass('fr-expanded');

        if (this.opts.trackChangesEnabled && this.opts.toolbarContainer && !hasClass || !this.opts.trackChangesEnabled && this.opts.toolbarContainer && hasClass) {
          this.$tb.find(".fr-more-toolbar[data-name=\"".concat($btn.attr('id'), "\"]")).toggleClass('fr-expanded');
          this.$box.toggleClass('fr-toolbar-open');
          this.$tb.toggleClass('fr-toolbar-open');
          $btn.toggleClass('fr-open');
        }

        $btn.toggleClass('fr-active', this.opts.trackChangesEnabled).attr('aria-pressed', this.opts.trackChangesEnabled);
      }
    }
  });
  FE.RegisterCommand('showChanges', {
    type: 'button',
    icon: 'showChanges',
    title: 'Show Changes',
    plugin: 'track_changes',
    undo: false,
    focus: false,
    accessibilityFocus: true,
    forcedRefresh: true,
    refreshAfterCallback: true,
    toggle: true,
    callback: function callback() {
      this.track_changes.showChanges();
    },
    refresh: function refresh($btn) {
      $btn.toggleClass('fr-active', this.opts.showChangesEnabled).attr('aria-pressed', this.opts.showChangesEnabled);
    }
  });
  FE.RegisterCommand('applyAll', {
    type: 'button',
    icon: 'applyAll',
    title: 'Accept All Changes',
    plugin: 'track_changes',
    toggle: true,
    refreshAfterCallback: true,
    forcedRefresh: true,
    callback: function callback() {
      if (this.track_changes.getPendingChanges().length > 0) {
        this.track_changes.acceptAllChanges();
      }
    },
    refresh: function refresh($btn) {
      if (this.opts.trackChangesEnabled) this.track_changes.refresh($btn);
    }
  });
  FE.RegisterCommand('removeAll', {
    type: 'button',
    icon: 'removeAll',
    title: 'Reject All Changes',
    plugin: 'track_changes',
    toggle: true,
    refreshAfterCallback: true,
    forcedRefresh: true,
    callback: function callback() {
      if (this.track_changes.getPendingChanges().length > 0) {
        this.track_changes.rejectAllChanges();
      }
    },
    refresh: function refresh($btn) {
      if (this.opts.trackChangesEnabled) this.track_changes.refresh($btn);
    }
  });
  FE.RegisterCommand('applyLast', {
    type: 'button',
    icon: 'applyLast',
    title: 'Accept Single Change',
    plugin: 'track_changes',
    toggle: true,
    refreshAfterCallback: true,
    forcedRefresh: true,
    callback: function callback() {
      if (this.track_changes.getPendingChanges().length > 0) {
        this.track_changes.acceptSingleChange();
      }
    },
    refresh: function refresh($btn) {
      if (this.opts.trackChangesEnabled) this.track_changes.refresh($btn);
    }
  });
  FE.RegisterCommand('removeLast', {
    type: 'button',
    icon: 'removeLast',
    title: 'Reject Single Change',
    plugin: 'track_changes',
    toggle: true,
    refreshAfterCallback: true,
    forcedRefresh: true,
    callback: function callback() {
      if (this.track_changes.getPendingChanges().length > 0) {
        this.track_changes.rejectSingleChange();
      }
    },
    refresh: function refresh($btn) {
      if (this.opts.trackChangesEnabled) this.track_changes.refresh($btn);
    }
  });

})));
//# sourceMappingURL=track_changes.js.map
